import { useEffect } from "react";
import {
  ensureSongSimpliPortalCookies,
  hydrateVisitorCookiesFromQuery,
  loadVisitorScript,
} from "@/utils/visitor";

/** Loads visitor.js on mount so visitGuid cookies are available for tracking APIs. */
export default function useVisitorTracking(): void {
  useEffect(() => {
    hydrateVisitorCookiesFromQuery();
    ensureSongSimpliPortalCookies();
    loadVisitorScript();
  }, []);
}
